import { render } from "./OuterMetadataInput.vue?vue&type=template&id=9d271ec4&scoped=true&ts=true"
import script from "./OuterMetadataInput.vue?vue&type=script&lang=ts"
export * from "./OuterMetadataInput.vue?vue&type=script&lang=ts"

import "./OuterMetadataInput.vue?vue&type=style&index=0&id=9d271ec4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d271ec4"]])

export default __exports__